"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("../../../utils");
const TitleSubtitleDiversity_1 = __importDefault(require("../../atoms/TitleSubtitleDiversity"));
const DiversityOverlayProvider_1 = require("../../context/DiversityOverlayProvider");
const hooks_1 = require("../../hooks");
const OfflineWarningMessage_1 = __importDefault(require("../../molecules/OfflineWarningMessage"));
const subtitle = [
    (0, i18n_1.Localized)(i18n_1.Strings.diversity.secondPage.subtitle1),
    (0, i18n_1.Localized)(i18n_1.Strings.diversity.secondPage.subtitle2),
];
function PhenotypeSelectionPage() {
    const { isMobile } = (0, device_1.usePlatform)();
    const { state, dispatch } = (0, hooks_1.useDiversityOverlay)();
    const { selectedSkinTone, selectedPhenotype, selectedSex } = state;
    /**
     * '5' for grayscaled faces when CYS is opened first
     */
    const skinTone = selectedSkinTone || '5';
    const isGrayScaled = !selectedSkinTone;
    const Images = (0, utils_1.getPhenotypeImages)(skinTone, isMobile);
    const isPhenotypeSelected = (index) => {
        let selectedPhenotypeIndex = Images.findIndex(image => image === `${selectedSex}_head_${selectedPhenotype}-${skinTone}`);
        return index === selectedPhenotypeIndex;
    };
    const onSelectPhenotype = (face) => {
        dispatch((0, DiversityOverlayProvider_1.setSelectedPhenotype)(face.slice(-3)[0]));
        dispatch((0, DiversityOverlayProvider_1.setSelectedSex)(face.split('_')[0]));
    };
    return ((0, jsx_runtime_1.jsxs)(ContentContainer, { "data-e2e": 'PhenotypeSelectionPage_ContentContainer', children: [(0, jsx_runtime_1.jsx)(TitleSubtitleDiversity_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.diversity.secondPage.title), subtitle: subtitle, "$isList": true, "data-e2e": 'PhenotypeSelectionPage_TitleSubtitleDiversity' }), (0, jsx_runtime_1.jsxs)(ImageContainer, { "data-e2e": 'PhenotypeSelectionPage_ImageContainer', children: [(0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'PhenotypeSelectionPage_Container', children: Images.map((face, index) => ((0, jsx_runtime_1.jsx)(ImageBackground, { onClick: () => onSelectPhenotype(face), "aria-selected": isPhenotypeSelected(index), "aria-label": `${face}`, "data-e2e": 'PhenotypeSelectionPage_ImageBackground', children: (0, jsx_runtime_1.jsx)(Mask, { "data-e2e": 'PhenotypeSelectionPage_Mask', children: (0, jsx_runtime_1.jsx)(Image, { src: (0, utils_1.getImage)(face), alt: face, "$isGrayScaled": isGrayScaled, "data-e2e": 'PhenotypeSelectionPage_Image' }) }) }, face))) }), (0, jsx_runtime_1.jsx)(OfflineWarningMessage_1.default, { "data-e2e": 'PhenotypeSelectionPage_OfflineWarningMessage' })] })] }));
}
exports.default = PhenotypeSelectionPage;
const Container = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(2, 162px);
  row-gap: 8px;
  justify-content: center;

  height: fit-content;

  margin: 0 auto 30px auto;

  padding-bottom: 80px;

  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    grid-template-columns: repeat(5, 176px);
    height: auto;
  `)};

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) ``)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    grid-template-columns: repeat(5, 176px);
    height: auto;
    margin-top: 16px;
  `)};
`;
const ImageContainer = styled_components_1.default.div `
  width: 57vw;
  max-height: 524px;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    width: 100vw;
    height: fit-content;
    min-height: 400px;
  `)};

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 20px 0 20px 15px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 560px;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    width: 100vw;
    margin: 0;
  `)};

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    max-height: 80vh;
  `)};
`;
const ImageBackground = (0, ui_1.withA11y)(styled_components_1.default.button `
  display: flex;
  justify-content: center;

  width: 168px;
  height: 168px;

  padding: 0;

  background-color: ${props => props['aria-selected'] ? props.theme.green : 'transparent'};
  border: none;
  border-radius: ${props => (props['aria-selected'] ? '50%' : '4px')};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    width: 192px;
    height: 192px;
  `)};
`);
const Image = styled_components_1.default.img `
  z-index: -1;

  width: 104px;
  height: 144px;
  margin: 25px auto 0px;

  ${({ $isGrayScaled }) => {
    return ($isGrayScaled &&
        (0, styled_components_1.css) `
        filter: grayscale(1);
      `);
}}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    width: 124px;
    height: 168px;
  `)}:
`;
const Mask = styled_components_1.default.div `
  z-index: 0;

  width: 168px;
  height: 168px;

  overflow: hidden;

  border-radius: 50%;

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    height: 192px;
    width: 192px;
  `)}:
`;
const ContentContainer = styled_components_1.default.div `
  position: static;

  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    flex-direction: column;
    height: 84vh;
    width: 100vw;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    height: 92vh;
    flex-direction: column;
    overflow: hidden;
  `)}

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 86vh;
  `)}

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    height: 70vh;
    margin-bottom: 140px;

    overflow: visible;
  `)}
`;
